module.exports = __webpack_public_path__ + "img/11.b07cff24.png";